export default {
  // ========== File selector ==========
  selectFileOrDrag: 'Select a file or drag it here...',
  browse: 'Browse',

  // ========== File validations ==========
  fileSizeExceeded: 'File size cannot exceed {maxSize}.',

  // ========== Upload states ==========
  saving: 'Saving...',
  uploadingFile: 'Uploading file...',
  pleaseWaitUpload: 'Please wait while the file is being uploaded.',

  // ========== Success messages ==========
  fileSaved: 'File saved.',

  // ========== Error messages ==========
  problemUploadingFile: 'There was a problem uploading the file.',
}
